import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RefreshIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Refresh",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.92 13.11h7.36s.1.01.15.01c.55 0 .99-.44.99-.99 0-.34-.17-.63-.42-.81S8.87 9.17 8.87 9.17c1.86-2.08 4.54-3.38 7.54-3.38.32 0 .65.01.96.05h-.04c3.89.48 7.16 3.54 8.54 7.99a2.031 2.031 0 0 0 3.97-.6c0-.21-.03-.42-.09-.61-1.87-5.97-6.43-10.11-11.88-10.79-.44-.05-.95-.08-1.46-.08-4.1 0-7.79 1.76-10.36 4.56S3.69 3.96 3.69 3.96c-.19-.19-.45-.3-.73-.3-.57 0-1.04.46-1.04 1.03v7.37c0 .57.46 1.03 1.03 1.04Zm25.89 5.77h-7.37s-.1-.01-.15-.01c-.55 0-.99.44-.99.99 0 .34.17.63.42.81s2.14 2.14 2.14 2.14a10.08 10.08 0 0 1-7.54 3.38c-.32 0-.64-.01-.95-.04h.04c-3.89-.48-7.16-3.54-8.54-7.99a2.031 2.031 0 0 0-3.97.6c0 .21.03.42.09.61 1.84 5.93 6.4 10.11 11.88 10.79.48.06 1.03.1 1.58.1 4.07-.06 7.72-1.8 10.29-4.57s2.35 2.34 2.35 2.34c.19.19.45.3.73.3.57 0 1.04-.46 1.04-1.03v-7.37c0-.57-.47-1.04-1.04-1.04h-.04Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11 12.14H3c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v6.86H11a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.11 14.49c-.54 0-1.03-.39-1.12-.94-.97-5.45-5.71-9.4-11.25-9.4h-.2c-8.22 0-11.36 7.01-11.49 7.31-.25.58-.92.85-1.5.59-.58-.25-.85-.92-.6-1.5.15-.35 3.84-8.69 13.59-8.69h.2a13.7 13.7 0 0 1 13.5 11.29c.11.62-.3 1.22-.92 1.33-.07.01-.14.02-.2.02ZM28.11 29.34c-.63 0-1.14-.51-1.14-1.14v-6.86h-6.86a1.14 1.14 0 1 1 0-2.28h8c.63 0 1.14.51 1.14 1.14v8c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 29.34h-.2a13.7 13.7 0 0 1-13.5-11.29c-.11-.62.3-1.22.92-1.33.63-.11 1.22.3 1.33.92.97 5.45 5.71 9.4 11.25 9.4h.2c8.22 0 11.36-7.01 11.49-7.31.25-.58.92-.85 1.5-.59.58.25.85.92.6 1.5-.15.35-3.84 8.69-13.59 8.69Z"
      })]
    })
  }));
};
RefreshIcon.displayName = 'RefreshIcon';